<div id="publications" class="publications bg-light mt-5 py-5">
    <div class="container">
        <div class="row mt-3">
            <div class="col-12">
                <h1 class="fw-bold title ps-3 display-5">
                    Publications
                </h1>
            </div>
            <div class="row">
                <div class="col-4">
                Please find our latest work on the <a href="https://scholar.google.com/citations?user=HzOdf-IAAAAJ&hl=en" target="_blank">Google Scholar</a> page.  
                </div>
            </div>
        </div>
    </div>
    <div class="container papers">
        <div class="row">
            <div class="col-12">
                <div class="tab-content mt-4" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                        aria-labelledby="pills-home-tab" tabindex="0">
                        <!-- --------------- -->
                        <div class="mb-2 fs-4">
                            Journal papers
                            <span class="fs-5 ms-2 text-secondary">( {{journalPapers.length}} )</span>
                        </div>
                        <table class="table align-middle table-striped table-bordered">
                            <thead class="bg-secondary text-light">
                                <tr class="small">
                                    <td class="text-center">No.</td>
                                    <td class="text-center fw-bold">Article Info</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of journalPapers; let i=index">
                                    <td class="text-center">{{journalPapers.length-i}}</td>
                                    <td class="p-3">
                                        <div class="mb-1">
                                            <span *ngIf="item.detailUrl==''">{{item.title}}</span>
                                            <a *ngIf="item.detailUrl!=''" [attr.href]="item.detailUrl" target="_blank">{{item.title}}</a>
                                        </div>
                                        <div class="small text-secondary">
                                            <span>
                                                <i class="bi bi-people-fill me-1"></i>
                                                {{item.authors}}
                                            </span>
                                        </div>
                                        <div class="small text-secondary">
                                            <span class="me-2">
                                                <i class="bi bi-bookmark-fill me-1"
                                                    *ngIf="item.journal!='' && item.conference!=''"></i>
                                                {{item.journal}}
                                            </span>
                                            <span>{{item.book}}</span>
                                            <span class="mx-3">
                                                <i class="bi bi-calendar2-check-fill me-1"></i>
                                                {{item.date}}
                                            </span>
                                            <a *ngIf="item.viewUrl!=''" class="small" [attr.href]="item.viewUrl" target="_blank">View Article</a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- ---------- -->
                        <div class="mt-5 mb-2 fs-4">
                            Selected conference papers
                            <span class="fs-5 ms-2 text-secondary">( {{conferencePapers.length}} )</span>
                        </div>
                        <table class="table align-middle table-striped table-bordered">
                            <thead class="bg-secondary text-light">
                                <tr class="small">
                                    <td class="text-center">No.</td>
                                    <td class="text-center fw-bold">Article Info</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of conferencePapers; let i=index">
                                    <td class="text-center">{{conferencePapers.length-i}}</td>
                                    <td class="p-3">
                                        <div class="mb-1">
                                            <a [attr.href]="item.detailUrl" target="_blank">{{item.title}}</a>
                                        </div>
                                        <div class="small text-secondary">
                                            <i class="bi bi-people-fill me-1"></i>
                                            {{item.authors}}
                                        </div>
                                        <div class="small text-secondary">
                                            <i class="bi bi-bookmark-fill me-1"
                                                *ngIf="item.journal!='' && item.conference!=''"></i>
                                            <span class="me-2">{{item.conference}}</span>
                                            <span>{{item.pages}}</span>
                                            <span class="mx-3">
                                                <i class="bi bi-calendar2-check-fill me-1"></i>
                                                {{item.date}}
                                            </span>
                                            <a class="small" [attr.href]="item.viewUrl" target="_blank">View Article</a>
                                        </div>
                                        <div class="small text-secondary" *ngIf="item.award">
                                            <i class="bi bi-award-fill"></i>
                                            {{item.award}}
                                        </div>                                        
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- =================== -->
                    <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab"
                        tabindex="0">
                        <table class="table align-middle table-striped">
                            <tbody>
                                <tr *ngFor="let item of papers.submitted; let i=index">
                                    <td class="px-3 text-danger">{{i+1}}</td>
                                    <td class="py-3">{{item}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="text-secondary fst-italic text-end">( *denotes the students
                            supervised )</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>